import { useLocalSearchParams } from 'expo-router'

import {
  NotificationsCommunitySettingsScreen,
  type TNotificationsCommunitySettingsScreenProps,
} from '@/src/features/settings/ui/screens/NotificationsCommunitySettingsScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

export default () => {
  const searchParams = useLocalSearchParams()
  const { idSlug, updateParametersToken } = filterSearchParams<TNotificationsCommunitySettingsScreenProps>(searchParams)
  if (!idSlug) return null
  return <NotificationsCommunitySettingsScreen idSlug={idSlug} updateParametersToken={updateParametersToken} />
}
